import loadable from "@loadable/component"
import { Navigate, RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const BolIssuingContractsLayout = loadable(
  async () => import("~/features/contracts/pages/BolIssuingContractsLayout"),
  { fallback: <></> },
)
const BolIssuingContractsPage = loadable(
  async () => import("~/features/contracts/pages/BolIssuingContractsView"),
  { fallback: <></> },
)
const BolIssuingContractLayout = loadable(
  async () => import("~/features/contracts/pages/BolIssuingContractLayout"),
  { fallback: <></> },
)
const BolIssuingContractDetailsPage = loadable(
  async () => import("~/features/contracts/pages/BolIssuingContractDetailsView"),
  { fallback: <></> },
)
const CargoOwnerContractsLayout = loadable(
  async () => import("~/features/contracts/pages/CargoOwnerContractsLayout"),
  { fallback: <></> },
)
const CargoOwnerContractsPage = loadable(
  async () => import("~/features/contracts/pages/CargoOwnerContractsView"),
  { fallback: <></> },
)
const CargoOwnerContractDetailsPage = loadable(
  async () => import("~/features/contracts/pages/CargoOwnerContractDetailsView"),
  { fallback: <></> },
)
const CargoOwnerContractUsagePage = loadable(
  async () => import("~/features/contracts/pages/CargoOwnerContractUsageView"),
  { fallback: <></> },
)
const CargoOwnerContractPriceTablesPage = loadable(
  async () =>
    import("~/features/contracts/pages/CargoOwnerContractPriceTablesView"),
  { fallback: <></> },
)
const CargoOwnerContractPriceTablePage = loadable(
  async () =>
    import("~/features/contracts/pages/CargoOwnerContractPriceTableView"),
  { fallback: <></> },
)

export const contractRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.contracts,
    element: <Navigate replace to='bol-issuing-company' />,
  },
  {
    path: APP_ROUTES.bolIssuingContracts,
    element: <BolIssuingContractsLayout />,
    children: [{ index: true, element: <BolIssuingContractsPage /> }],
  },
  {
    path: `${APP_ROUTES.bolIssuingContracts}/:contractId`,
    element: <BolIssuingContractLayout />,
    children: [{ index: true, element: <BolIssuingContractDetailsPage /> }],
  },
  {
    path: APP_ROUTES.cargoOwnerContracts,
    element: <CargoOwnerContractsLayout />,
    children: [
      { index: true, element: <CargoOwnerContractsPage /> },
      {
        path: ":contractId/contract",
        element: <CargoOwnerContractDetailsPage />,
      },
      {
        path: ":contractId/contract/:termId",
        element: <CargoOwnerContractPriceTablesPage />,
      },
      {
        path: ":contractId/contract/:termId/:priceTableId",
        element: <CargoOwnerContractPriceTablePage />,
      },
      { path: ":contractId", element: <CargoOwnerContractUsagePage /> },
    ],
  },
]
